var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',_vm._l((_vm.MembresDuMenage),function(membre){return _c('li',{key:membre.id},[_vm._v(_vm._s(membre.nom))])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }